/* Caleums display-only currency converter. Checkout always charges AED (third-party card gateway); this only
   shows approximate prices. Never touches JSON-LD, meta tags or form values: only visible "AED. x" money text. */
(() => {
  const d = document, root = d.documentElement, KEY = 'caleums-ccy';
  const country = (d.currentScript && d.currentScript.dataset.country) || '';
  const LIST = ['AED', 'GBP', 'USD', 'EUR', 'SAR', 'KWD', 'QAR', 'BHD', 'OMR', 'INR', 'CAD', 'AUD'];
  const BY_COUNTRY = { GB: 'GBP', US: 'USD', SA: 'SAR', KW: 'KWD', QA: 'QAR', BH: 'BHD', OM: 'OMR', IN: 'INR', CA: 'CAD', AU: 'AUD' };
  const EURO = 'AT BE CY DE EE ES FI FR GR HR IE IT LT LU LV MT NL PT SI SK';
  // Theme prices: "AED\u00a04,725" (non-breaking space, since 12 Oct); "AED. 4,725.00" is the shop money format
  // still used by Shopify-rendered text. Plain "AED 2,000" in copy (shipping thresholds) is left alone.
  const MONEY = /AED(?:\.\s?|\u00a0)(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?)/g;
  const SKIP = 'script,style,noscript,template,textarea,select,option,[data-cc-skip],.caleums-tabby,[name="checkout"],.cc-m';
  let rates = null, cur;

  let saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  // The device clock is a better hint than the IP country: VPNs, iCloud Private Relay and some mobile networks
  // geolocate UAE visitors abroad. A phone set to UAE time sees AED.
  let tz = '';
  try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
  if (LIST.indexOf(saved) >= 0) cur = saved;
  else if (!country || country === 'AE' || tz === 'Asia/Dubai') cur = 'AED';
  else cur = BY_COUNTRY[country] || (EURO.indexOf(country) >= 0 ? 'EUR' : 'USD');

  const fmtCache = {};
  const fmt = (v) => {
    const dp = v >= 100 ? 0 : 2, k = cur + dp;
    if (!fmtCache[k]) fmtCache[k] = new Intl.NumberFormat('en', { style: 'currency', currency: cur, minimumFractionDigits: dp, maximumFractionDigits: dp });
    return fmtCache[k].format(dp ? v : Math.round(v));
  };
  const convert = (aed) => aed * rates.AED / rates[cur];

  function paint(span) {
    const aed = parseFloat(span.dataset.aed);
    span.textContent = '≈ ' + fmt(convert(aed));
    if (span.dataset.main) {
      const s = d.createElement('small');
      s.className = 'cc-aed';
      s.textContent = 'AED ' + aed.toLocaleString('en', { maximumFractionDigits: 2 });
      span.appendChild(s);
    }
  }

  function wrap(node) {
    const text = node.data, main = node.parentElement.closest('.price-list--product sale-price');
    MONEY.lastIndex = 0;
    if (!MONEY.test(text)) return;
    const frag = d.createDocumentFragment();
    let last = 0;
    text.replace(MONEY, (m, num, i) => {
      if (i > last) frag.appendChild(d.createTextNode(text.slice(last, i)));
      const span = d.createElement('span');
      span.className = 'cc-m';
      span.dataset.o = m;
      span.dataset.aed = num.replace(/,/g, '');
      span.title = m + ', charged in AED at checkout';
      if (main) span.dataset.main = 1;
      paint(span);
      frag.appendChild(span);
      last = i + m.length;
    });
    if (last < text.length) frag.appendChild(d.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  }

  function scan(el) {
    if (!rates || cur === 'AED' || !el) return;
    if (el.nodeType === 3) { const p = el.parentElement; if (p && !p.closest(SKIP)) wrap(el); return; }
    if (el.nodeType !== 1 || el.closest(SKIP)) return;
    const w = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => ((n.data.indexOf('AED.') >= 0 || n.data.indexOf('AED\u00a0') >= 0) && !n.parentElement.closest(SKIP)) ? 1 : 2
    });
    const hits = [];
    while (w.nextNode()) hits.push(w.currentNode);
    hits.forEach(wrap);
  }

  function syncSelects(scope) {
    (scope || d).querySelectorAll('select[data-cc-select]').forEach((s) => { s.value = cur; });
  }

  function apply() {
    root.classList.toggle('cc-on', cur !== 'AED');
    syncSelects();
    if (cur === 'AED' || !rates) {
      d.querySelectorAll('.cc-m').forEach((s) => s.replaceWith(d.createTextNode(s.dataset.o)));
      return;
    }
    d.querySelectorAll('.cc-m').forEach(paint);
    scan(d.body);
  }

  function loadRates() {
    if (rates || cur === 'AED') return Promise.resolve();
    return fetch('https://cdn.shopify.com/s/javascripts/currencies.js')
      .then((r) => r.text())
      .then((t) => {
        const m = t.match(/rates:\{([^}]+)\}/), out = {};
        (m ? m[1] : '').split(',').forEach((p) => { const kv = p.split(':'); out[kv[0]] = parseFloat(kv[1]); });
        if (out.AED > 0 && LIST.every((c) => out[c] > 0)) rates = out;
      })
      .catch(() => {});
  }

  d.addEventListener('change', (e) => {
    const s = e.target;
    if (!s.matches || !s.matches('select[data-cc-select]')) return;
    cur = LIST.indexOf(s.value) >= 0 ? s.value : 'AED';
    try { localStorage.setItem(KEY, cur); } catch (err) {}
    start();
  });

  new MutationObserver((list) => {
    if (cur === 'AED') return;
    list.forEach((m) => {
      if (m.type === 'characterData') scan(m.target);
      else m.addedNodes.forEach((n) => { scan(n); if (n.nodeType === 1) syncSelects(n); });
    });
  }).observe(d.body, { childList: true, subtree: true, characterData: true });

  const start = () => loadRates().then(() => { if (!rates) cur = 'AED'; apply(); });
  syncSelects();
  root.classList.toggle('cc-on', cur !== 'AED');
  start();
})();
